import React from 'react'
import PropTypes from 'prop-types'

const UserPlusIcon = (props) => {
  const { color = '#000000', classes = 'w-20' } = props
  return (
    <svg
      width="23"
      height="19"
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M21.9375 7.52872H19.6875V5.27048C19.6875 4.95997 19.4344 4.70592 19.125 4.70592H18C17.6906 4.70592 17.4375 4.95997 17.4375 5.27048V7.52872H15.1875C14.8781 7.52872 14.625 7.78277 14.625 8.09327V9.22239C14.625 9.5329 14.8781 9.78695 15.1875 9.78695H17.4375V12.0452C17.4375 12.3557 17.6906 12.6097 18 12.6097H19.125C19.4344 12.6097 19.6875 12.3557 19.6875 12.0452V9.78695H21.9375C22.2469 9.78695 22.5 9.5329 22.5 9.22239V8.09327C22.5 7.78277 22.2469 7.52872 21.9375 7.52872ZM7.875 9.22239C10.3605 9.22239 12.375 7.20057 12.375 4.70592C12.375 2.21128 10.3605 0.189453 7.875 0.189453C5.38945 0.189453 3.375 2.21128 3.375 4.70592C3.375 7.20057 5.38945 9.22239 7.875 9.22239ZM11.025 10.3515H10.4379C9.65742 10.7114 8.78906 10.9161 7.875 10.9161C6.96094 10.9161 6.09609 10.7114 5.31211 10.3515H4.725C2.11641 10.3515 0 12.4757 0 15.0938V16.5617C0 17.4967 0.755859 18.2553 1.6875 18.2553H14.0625C14.9941 18.2553 15.75 17.4967 15.75 16.5617V15.0938C15.75 12.4757 13.6336 10.3515 11.025 10.3515Z"
        fill={color}
      />
    </svg>
  )
}

UserPlusIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(UserPlusIcon)
